__turbopack_context__.v({
  "products": "styles-module__3PATKa__products",
  "soldOutWrapper": "styles-module__3PATKa__soldOutWrapper",
  "userDetailsAnchor": "styles-module__3PATKa__userDetailsAnchor",
  "wrapper": "styles-module__3PATKa__wrapper",
});
